var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"breadcrumb"},[_c('ul',{staticClass:"nav-breadcrumb"},_vm._l((_vm.breadcrumbs),function(crumb,index){return _c('li',{key:index,staticClass:"breadcrumb-item"},[(index + 1 === _vm.breadcrumbs.length)?_c('span',[_vm._v(_vm._s(crumb.content))]):_c('hot-link',_vm._b({},'hot-link',{
          label: index === 0 ? `${_vm.$t('components.breadcrumb.home.content')}` : crumb.content,
          href: crumb.url,
          type: 'secondary',
        },false))],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }